import { render, staticRenderFns } from "./SalesComparisonChart.vue?vue&type=template&id=6a8addaa&scoped=true"
import script from "./SalesComparisonChart.vue?vue&type=script&lang=js"
export * from "./SalesComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./SalesComparisonChart.vue?vue&type=style&index=0&id=6a8addaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8addaa",
  null
  
)

export default component.exports